import script from "./RefreshUserPermissionsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./RefreshUserPermissionsDialog.vue?vue&type=script&setup=true&lang=js"

import "./RefreshUserPermissionsDialog.vue?vue&type=style&index=0&id=1a5951c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a5951c2"]])

export default __exports__